import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../store';
import { queryParser } from '@applyft-web/utils';
import { getUserInfo, getUserLocation, selectPaymentSettingsStatus } from '../store/signup';

export const useRemarketingAuth = (enabled: boolean = false): boolean => {
  const dispatch = useAppDispatch();
  const { search } = useLocation();
  const navigate = useNavigate();
  const status = useSelector(selectPaymentSettingsStatus);
  const [locationLoaded, setLocationLoaded] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    Promise.resolve(getUserLocation()(dispatch)).finally(() => setLocationLoaded(true));

    if (!enabled) return;
    const { t } = queryParser(search);

    if (t) {
      getUserInfo(t)(dispatch);
    } else {
      navigate('/');
    }
  }, [enabled, dispatch, search, navigate]);

  useEffect(() => {
    if (!locationLoaded) return;

    if (!enabled) {
      setIsSuccess(true);
      return;
    }

    if (status === 'success') {
      setIsSuccess(true);
    } else if (status) {
      navigate('/');
    }
  }, [enabled, status, locationLoaded, navigate]);

  return isSuccess;
};
